.pure-u-1
  form.pure-form.pure-form-stacked.pure-g
    .pure-u-1-2
      input(name="name", type="text", placeholder="Name...", autofocus, autocomplete="off")
    .pure-u-1-3
      .btn-group
        button(data-hook="cancel").pure-button: i.ion-close
        button(type="submit", disabled).pure-button.pure-button-primary Event erstellen
